export const getState = (store) => store;
export const getProducts = (store) => store.search.products;
export const getProductFromState = (store) => store.product;
export const getAuctionFromState = (store) => ({ auction: store.product.auction, currency: store.product.currency });
export const getMarketplaceTypeFromState = (store) => ({ marketplaceType: store.product.marketplaceType, otherSettings: store.product.otherSettings });
export const getProductPageSettings = (store) => ({ customAttributes: store.product.customAttributes });
export const getSearchFromState = (store) => store.search;
export const getConfigFromState = (store) => store.config;
export const getSearchParams = (store) => store.search.searchParams;
export const getFilterAttributes = (store) => ({ filterAttributes: store.search.filterAttributes, numericFilterAttributes: store.search.numericFilterAttributes, searchParams: store.search.searchParams });
export const getAutocompleteData = (store) => {
	const { search } = store;
	const customAttributes = search.searchComponents && search.searchComponents.customAttributes ? search.searchComponents.customAttributes : {};
	const otherSettings = search.searchComponents && search.searchComponents.otherSettings ? search.searchComponents.otherSettings : {};

	return {
		calendarDisplayType: otherSettings && otherSettings.search_bar
			? otherSettings.search_bar.calendar_filter_position
			: null,
		deliveryDateShowStartOnly: search['delivery.deliveryDateValues'] === 'Start Date Only',
		displaySplitFields: search.displaySplitFields,
		googleMapAPIKey: search.googleMapAPIKey,
		marketplaceType: search.marketplaceType,
		productAttributes: search.productAttributes,
		searchByType: otherSettings && otherSettings.search_bar
			? otherSettings.search_bar.search_results
			: null,
		searchBarDisplayType: customAttributes && customAttributes.search_bar
			? customAttributes.search_bar
			: null,
		searchParams: search.searchParams,
	};
};
export const getHeaderPropsFromState = (store) => {
	const { search } = store;
	const customAttributes = search.searchComponents && search.searchComponents.customAttributes ? search.searchComponents.customAttributes : {};
	const otherSettings = search.searchComponents && search.searchComponents.otherSettings ? search.searchComponents.otherSettings : {};

	return {
		displaySplitFields: search.displaySplitFields,
		filterDisplayType: customAttributes && customAttributes.filter
			? customAttributes.filter
			: null,
		googleMapAPIKey: search.googleMapAPIKey,
		headerStyleType: otherSettings && otherSettings.header
			? otherSettings.header.header_style
			: null,
		headerText: otherSettings && otherSettings.header
			? otherSettings.header.header_text
			: null,
		marketplaceType: search.marketplaceType,
		logoDisplayType: customAttributes && customAttributes.logo
			? customAttributes.logo
			: null,
		menuItemsDisplayType: customAttributes && customAttributes.menu_items
			? customAttributes.menu_items
			: null,
		// product: search.product,
		searchBarDisplayType: customAttributes && customAttributes.search_bar
			? customAttributes.search_bar
			: null,
		searchByType: otherSettings && otherSettings.search_bar
			? otherSettings.search_bar.search_results
			: null,
		sortDisplayType: customAttributes && customAttributes.search_bar
			? customAttributes.sort_price
			: null,
		websiteURL: search.websiteURL,
	};
};

export const getDateIntervalState = (store) => {
	const { availableIntervals, singleDate, product } = store.product;

	return {
		availableIntervals,
		singleDate,
		product,
	};
};
